<template>
  <div>
    <PaymentCalculatorDetail class="cyFinanceTaxes" :details="taxDetails"> </PaymentCalculatorDetail>
    <PaymentCalculatorDetail class="cyFinanceDetails" :details="financeDetails"> </PaymentCalculatorDetail>
    <PaymentCalculatorDetail class="lead font-weight-bold text-dark cyFinancePayment" :details="paymentDetails">
    </PaymentCalculatorDetail>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import PaymentCalculatorDetail from '@/components/shared/payment-calculator/PaymentCalculatorDetail.vue';

export default {
  name: 'PaymentDetailsFinance',
  components: {
    PaymentCalculatorDetail,
  },
  data() {
    return {};
  },
  computed: {
    ...mapState('paymentCalculator', ['finance', 'financePaymentTerm', 'paymentPeriod']),
    ...mapGetters({
      languageCode: 'user/getLanguageCodeForNumericalInternationalization',
      taxRate: 'paymentCalculator/taxRate',
    }),
    taxDetails() {
      return [
        {
          name: `${this.$t('message.eCommerceV2.paymentCalculator.taxes')} (${this.$n(
            this.taxRate,
            'percent',
            this.languageCode
          )})`,
          value: this.$n(this.finance.salesTax, 'currency', this.languageCode),
        },
      ];
    },
    financeDetails() {
      return [
        {
          name: this.$t('message.eCommerceV2.paymentCalculator.amountFinanced'),
          value: this.$n(this.finance.amountFinanced, 'currency', this.languageCode),
        },
        {
          name: this.$t('message.eCommerceV2.paymentCalculator.rate'),
          value: this.$n(this.finance.interestRate, 'percent2FractionDigits', this.languageCode),
        },
        {
          name: this.$t('message.eCommerceV2.paymentCalculator.financeTerm'),
          value: `${this.financePaymentTerm} ${this.$t('message.eCommerceV2.paymentCalculator.months')}`,
        },
        {
          name: this.$t('message.eCommerceV2.paymentCalculator.costOfBorrowing'),
          value: this.$n(this.finance.costOfBorrowing, 'currency', this.languageCode),
        },
      ];
    },
    paymentDetails() {
      return [
        {
          name: `${this.$t(`message.eCommerceV2.paymentCalculator.${this.paymentPeriod}`)} ${this.$t(
            'message.eCommerceV2.paymentCalculator.payment'
          )}`,
          value: this.$n(this.finance.paymentAmount, 'currency', this.languageCode),
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped></style>
